export default "__VITE_ASSET__CJoM5GMx__"